import React from 'react';
import { useOnlineStatus } from '../hooks/useOnlineStatus.js';

const OfflineBanner = () => {
    const isOnline = useOnlineStatus();
    if (isOnline) return null;

    return (
        <div className="sticky top-0 z-[60] w-full bg-amber-500/15 border-b border-amber-500/30 backdrop-blur px-4 py-2 text-center text-xs sm:text-sm font-medium text-amber-200">
            Offline — studying cached decks. New cards, exams, and Flash Notes require a connection.
        </div>
    );
};

export default OfflineBanner;
